import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  PhoneAuthProvider,
  ConfirmationResult,
  signInWithCredential,
} from 'firebase/auth';
import { ToastrService } from 'ngx-toastr';
import { LoaderServiceService } from 'src/app/Services/loader-service.service';
import { APIService } from 'src/app/Services/main-service.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-e-certificate',
    imports: [ReactiveFormsModule, FormsModule, CommonModule],
    templateUrl: './e-certificate.component.html',
    styleUrl: './e-certificate.component.css'
})
export class ECertificateComponent {
certificateForm!: FormGroup;
 app = initializeApp(environment.firebaseConfig);
  auth = getAuth(this.app);
  recaptchaVerifier: RecaptchaVerifier | undefined;
  verificationId: string = '';
  showOTPfield:boolean=false;
  verificationCode: string = '';
   certificateDetails: any = null;
selectedCertificate: any = null;

  constructor(private fb: FormBuilder,
    private http: HttpClient,
    private toastr: ToastrService,
    private Service: APIService,
     private loaderService: LoaderServiceService,
    private route: ActivatedRoute,
    private router: Router) {}

   ngAfterViewInit() {
    if (!this.recaptchaVerifier) {
      this.recaptchaVerifier = new RecaptchaVerifier(this.auth,
        'recaptcha-container', // ID of the element to render reCAPTCHA
        { size: 'invisible' }, // Provide options as an object
      );
    }
  }

  ngOnInit(): void {
   this.certificateForm = this.fb.group({
  certificateNumber: ['', [
    Validators.pattern(/^RS-\d{10,}$/)
  ]],
  phoneNumber: ['', [
    Validators.pattern(/^\d{10}$/)
  ]]
});

 const certId = this.route.snapshot.paramMap.get('certificateId');
  if (certId) {
    this.getCertificateDetails(certId);
  }
  }

 onSubmit(): void {
  const { certificateNumber, phoneNumber } = this.certificateForm.value;

  if (!certificateNumber && !phoneNumber) {
    this.toastr.error('Please enter either a certificate number or a phone number.', 'Failed');
    return;
  }

  if (this.certificateForm.invalid) {
    this.toastr.error('Form is invalid. Please correct the errors.', 'Validation Failed');
    this.certificateForm.markAllAsTouched(); // Show validation errors
    return;
  }

  if (certificateNumber) {
   this.getCertificateDetails(this.certificateForm.value.certificateNumber);
    // this.searchByCertificateNumber(certificateNumber);
  } else if (phoneNumber) {
   this.verifyPhone(phoneNumber)
  }
}


 verifyPhone(phone: string): void {
   this.loaderService.show();
    this.Service.checkPhoneExists(phone).subscribe({
      next: (res) => {
        this.sendVerificationCode(phone);
        console.log('Phone check result:', res);
        // You can show toast or message based on response
      },
      error: (err) => {
         this.loaderService.hide()
        this.toastr.error('Certificate not found.', 'Failed');
      }
    });
  }

 sendVerificationCode(phoneNumber:any) {
    const appVerifier = this.recaptchaVerifier;
    signInWithPhoneNumber(this.auth, '+91'+phoneNumber, appVerifier)
      .then((confirmationResult: ConfirmationResult) => {
        this.verificationId = confirmationResult.verificationId;
         this.loaderService.hide()
         this.toastr.success('Verification Code Sent Successfully', 'Success');
        this.showOTPfield=true
      })
      .catch((error: any) => {
         this.loaderService.hide()
        this.toastr.error('Something went wrong', 'Failed');
      });
  }

  verifyCode() {
     this.loaderService.show();
    const credential = PhoneAuthProvider.credential(
      this.verificationId,
      this.verificationCode
    );
    signInWithCredential(this.auth, credential) // Import signInWithCredential
      .then((userCredential:any) => {
        this.toastr.success('OTP Verified Successfully', 'Success');
         this.getCertificateDetails(this.certificateForm.value.phoneNumber);
          
      })
      .catch((error: any) => {
        this.loaderService.hide()
this.toastr.error('Something went wrong', 'Failed');

      });
    }

     getCertificateDetails(search:any) {
   this.loaderService.show();

    this.Service.searchCertificate(search).subscribe({
      next: (res) => {
        this.certificateDetails = res.data;
        this.loaderService.hide()
      },
      error: (err) => {
        this.toastr.error('Invalid details', 'Failed');
        this.loaderService.hide()
      }
    });
  }

 certificatePopUP(detail: any) {
    this.selectedCertificate = detail;
  }

  resetCertificateForm() {
  this.certificateForm.reset(); // clears form controls
  this.certificateDetails = null; // clear any result if needed
  this.showOTPfield=false
  this.router.navigate(['/e-certificate']);
}

markCertificateAsdownloaded(data:any){
  this.loaderService.show()
    this.Service.markCertificateDownloaded(data).subscribe({
      next: (res) => {
       
        this.loaderService.hide()
      },
      error: (err) => {
       
        this.loaderService.hide()
      }
    });
}

downloadCertificate(): void {
const certificateNo={
    "certificate_no": this.selectedCertificate.certificate_id
}
  this.markCertificateAsdownloaded(certificateNo)
  if (typeof window === 'undefined') return;

  // Wait a tiny bit to ensure Angular has rendered after selectedCertificate is set
  setTimeout(() => {
    const element = document.getElementById('certificateContent');
    if (!element) {
      console.error('certificateContent not found in DOM');
      return;
    }
  this.loaderService.show();

    const clone = element.cloneNode(true) as HTMLElement;

    // Style it for proper layout and rendering
    clone.style.display = 'block';
    clone.style.width = '1090px';
    clone.style.height = '729.6px';
clone.style.marginBottom = '0';
clone.style.paddingBottom = '0';
    // Wrap in an off-screen container
    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'fixed';
    tempContainer.style.top = '-10000px';
    tempContainer.style.left = '-10000px';
    tempContainer.style.zIndex = '-1';
    tempContainer.appendChild(clone);

    document.body.appendChild(tempContainer);

    import('html2pdf.js').then((html2pdf) => {
      const opt = {
        margin: [0, 0.2, 0, 0.2],
        filename: `${this.selectedCertificate?.name || 'certificate'}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
      };

      html2pdf
        .default()
        .from(clone)
        .set(opt)
        .save()
        .then(() => {
          document.body.removeChild(tempContainer);
        });
    });
    this.loaderService.hide()
    this.selectedCertificate=null
     this.toastr.success('Certificate Downloaded Successfully', 'Success');
  }, 100); // delay ensures the DOM has rendered after *ngIf
}





allowOnlyNumbers(event: KeyboardEvent): void {
  const charCode = event.charCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}

formatDateToDDMMYYYY(inputDate: string): string {
  const [year, month, day] = inputDate.split('-');
  return `${day}/${month}/${year}`;
}

}
